import { i18nGlobal } from "@/i18n"
import { useStoreError } from "@/stores/storeError"
import type { IntError } from "@functions/models/interfaces/intError"
import loggerLocal, { safeToStringLocal } from "./loggerLocal"
import { isEmptyCheckLocal } from "./utils"

export function showSuccessUpdateMessage () {
    loggerLocal.info( 'showSuccessUpdateMessage' )
    showMessage( i18nGlobal.t( 'error.updSuccess' ) )
}
export function showSuccessDocMessage () {
    showMessage( i18nGlobal.t( 'error.docSuccess' ) )
}

export function showSuccessInviteMessage () {
    showMessage( i18nGlobal.t( 'error.inviteSuccess' ) )
}

export function showErrorMessage ( msg?: string, techInfo?: any ) {
    const storeError = useStoreError()
    const msg2Show = msg ?? i18nGlobal.t( 'error.default' )

    const firebaseError = techInfo as any
    const newError: IntError = firebaseError?.details as IntError
    const functionName = newError?.functionName ?? ''
    const refId = newError?.refId ?? ''
    const status = newError?.status ?? ''
    const errorMessage = safeToStringLocal( newError?.message ?? '' )
    const errorCode = newError?.code ?? ''
    const execTS = newError?.execTS ?? ''
    const tech = `<strong>${ status } - ${ functionName }</strong> <br><br>
  ${ errorCode } - ${ errorMessage } <br><br>
  ${ refId } <br>
  ${ execTS } <br>`
    loggerLocal.error( 'showErrorMessage techInfo', msg2Show, techInfo, tech )
    const error2Show =
        isEmptyCheckLocal( newError ) && isEmptyCheckLocal( functionName ) ? safeToStringLocal( techInfo ) : tech
    storeError.setError( msg2Show, error2Show )
    loggerLocal.error( 'showErrorMessage', msg2Show, error2Show )
}
export function showMessage ( msg?: string, techInfo?: any ) {
    const storeError = useStoreError()
    const msg2Show = msg ?? i18nGlobal.t( 'error.default' )
    storeError.setSuccess( msg2Show, techInfo )
}